 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"view-About-vue":"view-About-vue","view-Cart-vue~view-Favorite-vue~view-Home-vue~view-Item-vue~view-Product-vue":"view-Cart-vue~view-Favorite-vue~view-Home-vue~view-Item-vue~view-Product-vue","view-Cart-vue":"view-Cart-vue","view-Favorite-vue":"view-Favorite-vue","view-Home-vue~view-Item-vue":"view-Home-vue~view-Item-vue","view-Home-vue":"view-Home-vue","view-Item-vue":"view-Item-vue","view-Product-vue":"view-Product-vue","view-Contact-vue":"view-Contact-vue","view-Login-vue":"view-Login-vue","view-Paymentmethod-vue":"view-Paymentmethod-vue","view-Policy-vue":"view-Policy-vue","view-Register-vue":"view-Register-vue","view-profile-Address-vue":"view-profile-Address-vue","view-profile-Order-vue":"view-profile-Order-vue","view-profile-OrderDetail-vue":"view-profile-OrderDetail-vue","view-profile-Profile-vue":"view-profile-Profile-vue","view-profile-ProfilePassword-vue":"view-profile-ProfilePassword-vue","view-profile-ProfileShow-vue":"view-profile-ProfileShow-vue","view-profile-ProfileUpdate-vue":"view-profile-ProfileUpdate-vue","view-test-vue":"view-test-vue"}[chunkId]||chunkId) + "." + {"view-About-vue":"79d774eb","view-Cart-vue~view-Favorite-vue~view-Home-vue~view-Item-vue~view-Product-vue":"f2e3e714","view-Cart-vue":"71f7b37f","view-Favorite-vue":"0b15d23b","view-Home-vue~view-Item-vue":"90a32a72","view-Home-vue":"6072104f","view-Item-vue":"97fcdcee","view-Product-vue":"cef57446","view-Contact-vue":"3807dea8","view-Login-vue":"080509db","view-Paymentmethod-vue":"55b910bf","view-Policy-vue":"f986f8e2","view-Register-vue":"59bec5f4","view-profile-Address-vue":"2114fd9d","view-profile-Order-vue":"36590094","view-profile-OrderDetail-vue":"3763bd8b","view-profile-Profile-vue":"eb1aa42c","view-profile-ProfilePassword-vue":"7badb47b","view-profile-ProfileShow-vue":"3c65b14a","view-profile-ProfileUpdate-vue":"25f29bbc","view-test-vue":"d0d80293"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"view-Cart-vue":1,"view-Favorite-vue":1,"view-Home-vue~view-Item-vue":1,"view-Home-vue":1,"view-Item-vue":1,"view-Product-vue":1,"view-Login-vue":1,"view-Register-vue":1,"view-profile-Order-vue":1,"view-profile-OrderDetail-vue":1,"view-profile-ProfileShow-vue":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"view-About-vue":"view-About-vue","view-Cart-vue~view-Favorite-vue~view-Home-vue~view-Item-vue~view-Product-vue":"view-Cart-vue~view-Favorite-vue~view-Home-vue~view-Item-vue~view-Product-vue","view-Cart-vue":"view-Cart-vue","view-Favorite-vue":"view-Favorite-vue","view-Home-vue~view-Item-vue":"view-Home-vue~view-Item-vue","view-Home-vue":"view-Home-vue","view-Item-vue":"view-Item-vue","view-Product-vue":"view-Product-vue","view-Contact-vue":"view-Contact-vue","view-Login-vue":"view-Login-vue","view-Paymentmethod-vue":"view-Paymentmethod-vue","view-Policy-vue":"view-Policy-vue","view-Register-vue":"view-Register-vue","view-profile-Address-vue":"view-profile-Address-vue","view-profile-Order-vue":"view-profile-Order-vue","view-profile-OrderDetail-vue":"view-profile-OrderDetail-vue","view-profile-Profile-vue":"view-profile-Profile-vue","view-profile-ProfilePassword-vue":"view-profile-ProfilePassword-vue","view-profile-ProfileShow-vue":"view-profile-ProfileShow-vue","view-profile-ProfileUpdate-vue":"view-profile-ProfileUpdate-vue","view-test-vue":"view-test-vue"}[chunkId]||chunkId) + "." + {"view-About-vue":"31d6cfe0","view-Cart-vue~view-Favorite-vue~view-Home-vue~view-Item-vue~view-Product-vue":"31d6cfe0","view-Cart-vue":"95d8720a","view-Favorite-vue":"67cf672b","view-Home-vue~view-Item-vue":"bd4dc35d","view-Home-vue":"44e3fe5f","view-Item-vue":"7a52d79b","view-Product-vue":"d098b9c4","view-Contact-vue":"31d6cfe0","view-Login-vue":"b119d7ae","view-Paymentmethod-vue":"31d6cfe0","view-Policy-vue":"31d6cfe0","view-Register-vue":"b119d7ae","view-profile-Address-vue":"31d6cfe0","view-profile-Order-vue":"44f963cd","view-profile-OrderDetail-vue":"378d29e7","view-profile-Profile-vue":"31d6cfe0","view-profile-ProfilePassword-vue":"31d6cfe0","view-profile-ProfileShow-vue":"201bb246","view-profile-ProfileUpdate-vue":"31d6cfe0","view-test-vue":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
